module.exports = __webpack_public_path__ + "static/Mewshi.258c22e1.png";